/*
 * Theme switcher (topbar dropdown). The applying side lives inline in
 * app/Presenters/templates/include/themeBoot.latte (window.finestTheme) so it runs before first paint;
 * this file only wires the dropdown and mirrors the choice to the per-user DB setting.
 */
(function ($) {
    "use strict";

    try { localStorage.removeItem("darkMode"); } catch (e) {} // key of the removed 2025 implementation

    $(document).on("click", ".js-theme-option", function (e) {
        e.preventDefault();
        var choice = $(this).data("theme-value");
        if (!window.finestTheme) return;
        window.finestTheme.set(choice);

        var url = $("#theme-switcher").data("url");
        if (url) {
            $.ajax({ url: url, method: "POST", data: { theme: choice }, dataType: "json" });
        }
    });
})(jQuery);
